export default __webpack_public_path__ + "9790d5c10bd35ba12ce6db9e36ba6ac6.png";